const ChatIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M17 8C17 4.13401 13.866 1 10 1C6.13401 1 3 4.13401 3 8C3 9.8 3.7 11.4 4.8 12.6L3 17L7.4 15.2C8.2 15.7 9.1 16 10 16C13.866 16 17 12.866 17 9V8Z" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="7" cy="8" r="0.5" fill="currentColor"/>
      <circle cx="10" cy="8" r="0.5" fill="currentColor"/>
      <circle cx="13" cy="8" r="0.5" fill="currentColor"/>
    </svg>
  );
};

export default ChatIcon;

